unit View.Subgrupos.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UUtils;

type
  TFViewSubgruposList = class(TForm)
    btNew: TButton;
    SubgruposDataset: TXDataWebDataSet;
    SubgruposDatasetid: TIntegerField;
    SubgruposDatasetaliado_id: TIntegerField;
    SubgruposDatasetdata_base_id: TIntegerField;
    SubgruposDatasetnome: TStringField;
    SubgruposDatasetgrupo_id: TIntegerField;
    SubgruposDatasetcodigo_interno: TIntegerField;
    SubgruposDatasetexcluido: TBooleanField;
    SubgruposDatasetinclusao: TDateTimeField;
    SubgruposDatasetalteracao: TDateTimeField;
    SubgruposDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchChange(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewSubgruposList: TFViewSubgruposList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewSubgruposList }

procedure TFViewSubgruposList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewSubgruposList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewSubgruposList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewSubgruposList, AElementID, Result, @AfterCreate);
end;

procedure TFViewSubgruposList.edSearchChange(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewSubgruposList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewSubgruposList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      SubgruposDataset.Connection.Model.DefaultSchema.FindEntityType(SubgruposDataset.EntitySetName),
      SubgruposDataset.CurrentData
    );
    Button := TButton.Create(nil);
    Button.Caption := 'Edit';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-outline btn-default btn-xs';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
  end;
end;

procedure TFViewSubgruposList.WebFormCreate(Sender: TObject);
begin
  TUtils.SetValorDicionarioClasses('subgrupos', 'active');
  TUtils.SetValorDicionarioClasses('produtos_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_produtos', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    SubgruposDataset,
    lcPaginator,
    lbPaginationInfo
  );
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewSubgruposList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.subgrupos.list.pagination.info');
  btNew := TButton.Create('view.subgrupos.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.subgrupos.list.table');
  cbPageSize := TComboBox.Create('view.subgrupos.list.cbPageSize');
  edSearch := TEdit.Create('view.subgrupos.list.search');
  lcPaginator := TListControl.Create('view.subgrupos.list.pagination');
  SubgruposDataset := TXDataWebDataSet.Create(Self);
  SubgruposDatasetid := TIntegerField.Create(Self);
  SubgruposDatasetaliado_id := TIntegerField.Create(Self);
  SubgruposDatasetdata_base_id := TIntegerField.Create(Self);
  SubgruposDatasetnome := TStringField.Create(Self);
  SubgruposDatasetgrupo_id := TIntegerField.Create(Self);
  SubgruposDatasetcodigo_interno := TIntegerField.Create(Self);
  SubgruposDatasetexcluido := TBooleanField.Create(Self);
  SubgruposDatasetinclusao := TDateTimeField.Create(Self);
  SubgruposDatasetalteracao := TDateTimeField.Create(Self);
  SubgruposDatasetexclusao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  SubgruposDataset.BeforeLoadDFMValues;
  SubgruposDatasetid.BeforeLoadDFMValues;
  SubgruposDatasetaliado_id.BeforeLoadDFMValues;
  SubgruposDatasetdata_base_id.BeforeLoadDFMValues;
  SubgruposDatasetnome.BeforeLoadDFMValues;
  SubgruposDatasetgrupo_id.BeforeLoadDFMValues;
  SubgruposDatasetcodigo_interno.BeforeLoadDFMValues;
  SubgruposDatasetexcluido.BeforeLoadDFMValues;
  SubgruposDatasetinclusao.BeforeLoadDFMValues;
  SubgruposDatasetalteracao.BeforeLoadDFMValues;
  SubgruposDatasetexclusao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  try
    Name := 'FViewSubgruposList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliado_id';
      Title := 'aliado_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_base_id';
      Title := 'data_base_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nome';
      Title := 'nome';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'grupo_id';
      Title := 'grupo_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_interno';
      Title := 'codigo_interno';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'excluido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'inclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'alteracao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'exclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'Actions';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnChange', 'edSearchChange');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    SubgruposDataset.SetParentComponent(Self);
    SubgruposDataset.Name := 'SubgruposDataset';
    SubgruposDataset.EntitySetName := 'Subgrupos';
    SubgruposDataset.Connection := DMConnection.ApiConnection;
    SubgruposDataset.Left := 72;
    SubgruposDataset.Top := 144;
    SubgruposDatasetid.SetParentComponent(SubgruposDataset);
    SubgruposDatasetid.Name := 'SubgruposDatasetid';
    SubgruposDatasetid.FieldName := 'id';
    SubgruposDatasetid.Required := True;
    SubgruposDatasetaliado_id.SetParentComponent(SubgruposDataset);
    SubgruposDatasetaliado_id.Name := 'SubgruposDatasetaliado_id';
    SubgruposDatasetaliado_id.FieldName := 'aliado_id';
    SubgruposDatasetaliado_id.Required := True;
    SubgruposDatasetdata_base_id.SetParentComponent(SubgruposDataset);
    SubgruposDatasetdata_base_id.Name := 'SubgruposDatasetdata_base_id';
    SubgruposDatasetdata_base_id.FieldName := 'data_base_id';
    SubgruposDatasetdata_base_id.Required := True;
    SubgruposDatasetnome.SetParentComponent(SubgruposDataset);
    SubgruposDatasetnome.Name := 'SubgruposDatasetnome';
    SubgruposDatasetnome.FieldName := 'nome';
    SubgruposDatasetnome.Required := True;
    SubgruposDatasetnome.Size := 255;
    SubgruposDatasetgrupo_id.SetParentComponent(SubgruposDataset);
    SubgruposDatasetgrupo_id.Name := 'SubgruposDatasetgrupo_id';
    SubgruposDatasetgrupo_id.FieldName := 'grupo_id';
    SubgruposDatasetgrupo_id.Required := True;
    SubgruposDatasetcodigo_interno.SetParentComponent(SubgruposDataset);
    SubgruposDatasetcodigo_interno.Name := 'SubgruposDatasetcodigo_interno';
    SubgruposDatasetcodigo_interno.FieldName := 'codigo_interno';
    SubgruposDatasetcodigo_interno.Required := True;
    SubgruposDatasetexcluido.SetParentComponent(SubgruposDataset);
    SubgruposDatasetexcluido.Name := 'SubgruposDatasetexcluido';
    SubgruposDatasetexcluido.FieldName := 'excluido';
    SubgruposDatasetinclusao.SetParentComponent(SubgruposDataset);
    SubgruposDatasetinclusao.Name := 'SubgruposDatasetinclusao';
    SubgruposDatasetinclusao.FieldName := 'inclusao';
    SubgruposDatasetalteracao.SetParentComponent(SubgruposDataset);
    SubgruposDatasetalteracao.Name := 'SubgruposDatasetalteracao';
    SubgruposDatasetalteracao.FieldName := 'alteracao';
    SubgruposDatasetexclusao.SetParentComponent(SubgruposDataset);
    SubgruposDatasetexclusao.Name := 'SubgruposDatasetexclusao';
    SubgruposDatasetexclusao.FieldName := 'exclusao';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := SubgruposDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    SubgruposDataset.AfterLoadDFMValues;
    SubgruposDatasetid.AfterLoadDFMValues;
    SubgruposDatasetaliado_id.AfterLoadDFMValues;
    SubgruposDatasetdata_base_id.AfterLoadDFMValues;
    SubgruposDatasetnome.AfterLoadDFMValues;
    SubgruposDatasetgrupo_id.AfterLoadDFMValues;
    SubgruposDatasetcodigo_interno.AfterLoadDFMValues;
    SubgruposDatasetexcluido.AfterLoadDFMValues;
    SubgruposDatasetinclusao.AfterLoadDFMValues;
    SubgruposDatasetalteracao.AfterLoadDFMValues;
    SubgruposDatasetexclusao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
  end;
end;

end.
